package pro.jayeshseth.animations.playground.model

enum class TweenNSpringSpec { Tween, Spring }